import { useEffect } from 'react'

/*
 * Prints (and saves as PDF) in the light theme, whatever theme is on screen. The dark theme isn't made for
 * paper: its navy surfaces came out as solid dark pages. Dark mode is a class on body, so it comes off for
 * the print and goes back on straight after.
 */
export const usePrintInLightTheme = (): void => {
  useEffect(() => {
    let wasDark = false
    const before = () => {
      wasDark = document.body.classList.contains('dark')
      if (wasDark) document.body.classList.remove('dark')
    }
    const after = () => {
      if (wasDark) document.body.classList.add('dark')
      wasDark = false
    }
    window.addEventListener('beforeprint', before)
    window.addEventListener('afterprint', after)
    return () => {
      window.removeEventListener('beforeprint', before)
      window.removeEventListener('afterprint', after)
      after()
    }
  }, [])
}
